"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentActionsButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const fa_1 = require("react-icons/fa");
const Button_1 = __importDefault(require("../../elements/Button"));
const styles = {
    button: { width: '16px', height: '16px', padding: 0 },
    icon: { fontSize: 9, margin: 'auto' },
};
function AssignmentActionsButtons(props) {
    const { isActive, onAssign, onUnAssign, x = 0, y = 5, className = 'target', ...otherProps } = props;
    return ((0, jsx_runtime_1.jsxs)("foreignObject", { width: "16px", height: "34px", x: x, y: y, className: className, "data-no-export": "true", children: [(0, jsx_runtime_1.jsx)(Button_1.default, { theme: "success", style: styles.button, onClick: onAssign, ...otherProps, children: (0, jsx_runtime_1.jsx)(fa_1.FaLink, { style: styles.icon }) }), isActive && ((0, jsx_runtime_1.jsx)(Button_1.default, { theme: "danger", style: { ...styles.button, marginTop: '2px' }, onClick: onUnAssign, ...otherProps, children: (0, jsx_runtime_1.jsx)(fa_1.FaMinus, { style: styles.icon }) }))] }));
}
exports.AssignmentActionsButtons = AssignmentActionsButtons;
